import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const PrivacyPage = () => {
  return <div className="min-h-screen bg-black text-white" data-id="element-419">
      <div className="container mx-auto px-4 py-16 max-w-4xl" data-id="element-420">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-421">
          <div className="flex justify-center mb-10" data-id="element-422">
            <Link to="/" data-id="element-423">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8FoTH3xeKncC1VAra4Rj1n/partners516.png" alt="516 Partners Logo" className="h-12 w-auto" data-id="element-424" />
            </Link>
          </div>
          <h1 className="typekit-heading text-3xl md:text-4xl text-center text-white mb-10" data-id="element-425">
            Privacy Policy
          </h1>
          <div className="text-gray-300 libre-caslon-text-regular space-y-8" data-id="element-426">
            <div className="mb-6" data-id="element-427">
              <p className="text-gray-400" data-id="element-428">
                <strong data-id="element-429">Effective Date:</strong> October 21, 2025
                <br data-id="element-430" />
                <strong data-id="element-431">Company Name:</strong> 516 Partners
                <br data-id="element-432" />
                <strong data-id="element-433">Website:</strong> https://516partners.com
                <br data-id="element-434" />
                <strong data-id="element-435">Contact:</strong> info@516partners.com
              </p>
            </div>
            <div className="mb-6" data-id="element-436">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-437">
                1. Introduction
              </h2>
              <p className="leading-relaxed" data-id="element-438">
                Your privacy is important to us. This Privacy Policy explains
                how 516 Partners collects, uses, and protects the information
                you provide when you interact with our website, advertisements,
                and services related to our Exit Readiness Assessment.
              </p>
            </div>
            <div className="mb-6" data-id="element-439">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-440">
                2. Information We Collect
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-441">We may collect:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-442">
                <li data-id="element-443">
                  <strong className="text-white" data-id="element-444">Personal Information:</strong>{' '}
                  Name, email address, phone number, and business name when you
                  apply or submit a form.
                </li>
                <li data-id="element-445">
                  <strong className="text-white" data-id="element-446">Business Information:</strong>{' '}
                  Details about your clinic or company such as revenue range,
                  industry, and goals, used solely to evaluate your readiness
                  for a potential sale.
                </li>
                <li data-id="element-447">
                  <strong className="text-white" data-id="element-448">Technical Information:</strong>{' '}
                  IP address, browser type, device identifiers, and cookies to
                  improve your browsing experience and analyze performance.
                </li>
              </ul>
            </div>
            <div className="mb-6" data-id="element-449">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-450">
                3. How We Use Your Information
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-451">
                We use your information to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-452">
                <li data-id="element-453">
                  Deliver assessments, reports, and related communications.
                </li>
                <li data-id="element-454">Contact you about next steps or relevant updates.</li>
                <li data-id="element-455">
                  Send educational materials and offers related to business
                  valuation, growth, and exit readiness.
                </li>
                <li data-id="element-456">Improve our website and marketing performance.</li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-457">
                516 Partners does not sell or rent your information to any third
                party.
              </p>
            </div>
            <div className="mb-6" data-id="element-458">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-459">
                4. Sharing Information
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-460">
                We may share information with:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-461">
                <li data-id="element-462">
                  Trusted vendors who provide services like CRM, email, or
                  analytics tools to support delivery of our services.
                </li>
                <li data-id="element-463">
                  Legal authorities when required by law or to protect our
                  rights.
                </li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-464">
                All partners are bound by confidentiality and data-protection
                agreements.
              </p>
            </div>
            <div className="mb-6" data-id="element-465">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-466">
                5. Cookies
              </h2>
              <p className="leading-relaxed" data-id="element-467">
                Our website uses cookies and similar technologies to understand
                user behavior and enhance performance. You can disable cookies
                in your browser settings if you prefer.
              </p>
            </div>
            <div className="mb-6" data-id="element-468">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-469">
                6. Data Security
              </h2>
              <p className="leading-relaxed" data-id="element-470">
                We take commercially reasonable steps to protect your
                information from unauthorized access, loss, or misuse. However,
                no online transmission is completely secure, and you share data
                at your own risk.
              </p>
            </div>
            <div className="mb-6" data-id="element-471">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-472">
                7. Your Rights
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-473">You may request to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-474">
                <li data-id="element-475">Access, correct, or delete your personal data.</li>
                <li data-id="element-476">Opt out of marketing communications at any time.</li>
              </ul>
              <p className="mt-3 leading-relaxed" data-id="element-477">
                To exercise your rights, contact us at info@516partners.com.
              </p>
            </div>
            <div className="mb-6" data-id="element-478">
              <h2 className="text-xl text-[#ffdf07] mb-3 typekit-heading" data-id="element-479">
                8. Updates to This Policy
              </h2>
              <p className="leading-relaxed" data-id="element-480">
                We may revise this policy periodically. Updates will be posted
                to this page with a new effective date. Continued use of our
                services after updates constitutes acceptance of the revised
                policy.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-481">
            <Link to="/" className="text-[#ffdf07] hover:underline" data-id="element-482">
              Return to Home
            </Link>
          </div>
        </motion.div>
      </div>
      <footer className="border-t border-gray-800 py-8 px-4 mt-16" data-id="element-483">
        <div className="max-w-4xl mx-auto text-center" data-id="element-484">
          <p className="text-gray-400 text-sm mb-4" data-id="element-485">
            © 2025 516 Partners LLC. All rights reserved.
          </p>
          <div className="flex justify-center space-x-4" data-id="element-486">
            <Link to="/privacypage" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-487">
              Privacy Policy
            </Link>
            <span className="text-gray-600" data-id="element-488">|</span>
            <Link to="/termsofservice" className="text-gray-500 hover:text-[#ffdf07] text-xs transition-colors" data-id="element-489">
              Terms of Service
            </Link>
          </div>
        </div>
      </footer>
    </div>;
};
export default PrivacyPage;